import axios from '../http'
import { IGetPricingParams, IGetPricingData } from './types'
import { IResponseData } from '@/api/types'

export const getPricingData = (parameters: IGetPricingParams) => {
  return axios.get<IResponseData<IGetPricingData>>(
    '/index.php?_m=price_rule&_a=get_price_rule_list',
    parameters
  )
}
